import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, HostBinding, HostListener, Inject, OnInit } from '@angular/core';

@Directive({ standalone: true, selector: '[safeShareLink]' })
export class SafeShareLinkDirective implements OnInit {
  initialHrefUrl: string; // with session token
  safeHrefUrl: string; // no session token
  target: string | null = null;

  constructor(
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly _elementRef: ElementRef,
  ) {}

  @HostBinding('href')
  get href(): string {
    return this.safeHrefUrl;
  }

  ngOnInit(): void {
    const element = this._elementRef.nativeElement as HTMLAnchorElement;
    this.initialHrefUrl = element.href;
    this.safeHrefUrl = this._getSafeUrl(this.initialHrefUrl);
    this.target = element.getAttribute('target');
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.target === '_blank') {
      window.open(this.initialHrefUrl, '_blank');
    } else {
      this._document.location.href = this.initialHrefUrl;
    }
  }

  private _getSafeUrl(href: string): string {
    const urlWithToken = new URL(href);
    urlWithToken.searchParams.delete('token');

    return urlWithToken.toString();
  }
}
